import { useEffect } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { useMsgContext } from "../contexts/MsgContext";
import { PosicionarPagina } from "../Utils/Helpers";

export const Msg = () => {
	const { show, setShow, msg } = useMsgContext();

	useEffect(() => {
		if (show) {
			PosicionarPagina();
		}
	}, [show]);

	return (
		<ToastContainer position={"top-end"} style={{ marginBottom: "200px" }}>
			<Toast show={show} onClose={() => setShow(false)} bg={"success"} delay={5000} autohide>
				<Toast.Body>{msg}</Toast.Body>
			</Toast>
		</ToastContainer>
	);
};
